import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {AuthenticationServiceProvider} from "./services/authentication/authentication.provider";
import {UserMenuComponent} from "./components/header/user-menu/user-menu.component";
import {HttpClientModule} from "@angular/common/http";
import {AuthInterceptorProvider} from "./interceptors/auth/auth.provider";
import {RootscopeServiceProvider} from "./services/rootscope/rootscope.provider";
import {LocationServiceProvider} from "./services/location/location.provider";
import {StateServiceProvider} from "@tva/ng-migration/core/services/state/state.provider";
import {QuickLinksComponent} from './components/header/quick-links/quick-links.component';
import {MatIconModule} from "@angular/material/icon";
import {MatMenuModule} from "@angular/material/menu";
import {MatButtonModule} from "@angular/material/button";
import {MatDividerModule} from "@angular/material/divider";
import {HeaderComponent} from './components/header/header.component';
import {NavigationMenuComponent} from "./components/header/navigation-menu/navigation-menu.component";
import {MenuItemComponent} from "./components/header/navigation-menu/menu-item/menu-item.component";
import {BreadcrumbsComponent} from './components/header/breadcrumbs/breadcrumbs.component';
import {SharedModule} from "@tva/ng-migration/shared/shared.module";
import "./core.downgrades";

@NgModule({
  declarations: [UserMenuComponent, NavigationMenuComponent, MenuItemComponent, QuickLinksComponent, HeaderComponent, BreadcrumbsComponent],
  providers: [AuthenticationServiceProvider, AuthInterceptorProvider, RootscopeServiceProvider, LocationServiceProvider, StateServiceProvider],
    imports: [CommonModule, HttpClientModule, MatIconModule, MatMenuModule, MatButtonModule, MatDividerModule, SharedModule],
  exports: [UserMenuComponent],
})
export class CoreModule {}
